
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as teamM442UbwkSdIRoaJI7s1WHoDmkAgbPX__45bsNWFWsNxJAMeta } from "/vercel/path0/app/pages/team.vue?macro=true";
import { default as indexXNEFQ_45BjAwM6CKVywW7WXWaOQOf9WzaBic0wLTXHAssMeta } from "/vercel/path0/app/pages/index.vue?macro=true";
import { default as showcaseh9CKeTtaFu9RmDzFH_45LBfcr7mWlQo4cXJ_45whU51AJZAMeta } from "/vercel/path0/app/pages/showcase.vue?macro=true";
import { default as templates3JuNNrKRIC9lVJc5Ic10i1NSu1qDr2BdnYi8Y3c2wroMeta } from "/vercel/path0/app/pages/templates.vue?macro=true";
import { default as indexaRLkqFYQWbP0_45Tby87Q1jWH11wlsDi_Wpy86jOxYmNIMeta } from "/vercel/path0/app/pages/blog/index.vue?macro=true";
import { default as design_45kitAdXw4NbEOHmPEanpya2nd51NLlm_pYDFenBlmwVXLt4Meta } from "/vercel/path0/app/pages/design-kit.vue?macro=true";
import { default as jobsui3znLVjPPi1uvIO7NuS_45QJIZwM8xy_LgNPI4ttmQTUMeta } from "/vercel/path0/app/pages/enterprise/jobs.vue?macro=true";
import { default as support7YNSDjkZ1vNxFq7kPcTjA0Ia5kB_rl9F5fxFoZzHiPQMeta } from "/vercel/path0/app/pages/enterprise/support.vue?macro=true";
import { default as sponsorsqSnf0SJ24yxiQ_45ITbF0iFg2TQ4pmCaAwaGHmnSOJVgMMeta } from "/vercel/path0/app/pages/enterprise/sponsors.vue?macro=true";
import { default as indexdh5KEN3wnXEhpLEGUlAG2S9f0rx3sSUyx4CAF6Uvbw8Meta } from "/vercel/path0/app/pages/enterprise/agencies/index.vue?macro=true";
import { default as _91slug_93JKyIiTBK8ePEQRrGalD6GzjrE_45k30_45eVSubgbkdVX6QMeta } from "/vercel/path0/app/pages/enterprise/agencies/[slug].vue?macro=true";
import { default as enterprise9ZB5_KjAa7UI_45UGnVlj_453tEPjG0IO0V6UQoFvkfKQEAMeta } from "/vercel/path0/app/pages/enterprise.vue?macro=true";
import { default as newslettern4GOb5QWXQJ5kM06NFdIlERlYnW_459hqvAMGSs5DZn3kMeta } from "/vercel/path0/app/pages/newsletter.vue?macro=true";
import { default as _91slug_93V5fV_c16JVJ6sOuGL8Wo8dfppaMqN_45wRcqM9kt2Zm5YMeta } from "/vercel/path0/app/pages/blog/[slug].vue?macro=true";
import { default as indexicxDjlXg087w7w6CUqyqwMldMLtROSaz6jMBwBw1JcUMeta } from "/vercel/path0/app/pages/deploy/index.vue?macro=true";
import { default as _91slug_93_ksw8fq6FRuQ4uaNnbYgAzfG0fklryQ204pz9_RDvaUMeta } from "/vercel/path0/app/pages/deploy/[slug].vue?macro=true";
import { default as indexujR_45H8Cu1L2s4oCJBKSzWX3Bn1mbWcGA_oIqsbBAGR8Meta } from "/vercel/path0/app/pages/modules/index.vue?macro=true";
import { default as video_45coursesNEh0ujp9_45IaJpKCGLKWycaqjaVK9Cj04AvwlHbaheL8Meta } from "/vercel/path0/app/pages/video-courses.vue?macro=true";
import { default as _91_46_46_46slug_93OUNKk7AMQ1VVXePpxx0zUP0UVhd9HLJ7HMG1pdCiK_45IMeta } from "/vercel/path0/app/pages/docs/[...slug].vue?macro=true";
import { default as _91slug_93br5bsBMaFUldu9ZW3X_45bIirDQhXcQ74oasqLdJl3UNUMeta } from "/vercel/path0/app/pages/modules/[slug].vue?macro=true";
import { default as component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta } from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.13.10_better-sqli_a937dd94029dbe3564a583237b32d6f1/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0 } from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.13.10_better-sqli_a937dd94029dbe3564a583237b32d6f1/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "team",
    path: "/team",
    meta: teamM442UbwkSdIRoaJI7s1WHoDmkAgbPX__45bsNWFWsNxJAMeta || {},
    component: () => import("/vercel/path0/app/pages/team.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexXNEFQ_45BjAwM6CKVywW7WXWaOQOf9WzaBic0wLTXHAssMeta || {},
    component: () => import("/vercel/path0/app/pages/index.vue")
  },
  {
    name: "showcase",
    path: "/showcase",
    meta: showcaseh9CKeTtaFu9RmDzFH_45LBfcr7mWlQo4cXJ_45whU51AJZAMeta || {},
    component: () => import("/vercel/path0/app/pages/showcase.vue")
  },
  {
    name: "templates",
    path: "/templates",
    meta: templates3JuNNrKRIC9lVJc5Ic10i1NSu1qDr2BdnYi8Y3c2wroMeta || {},
    component: () => import("/vercel/path0/app/pages/templates.vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: indexaRLkqFYQWbP0_45Tby87Q1jWH11wlsDi_Wpy86jOxYmNIMeta || {},
    component: () => import("/vercel/path0/app/pages/blog/index.vue")
  },
  {
    name: "design-kit",
    path: "/design-kit",
    meta: design_45kitAdXw4NbEOHmPEanpya2nd51NLlm_pYDFenBlmwVXLt4Meta || {},
    component: () => import("/vercel/path0/app/pages/design-kit.vue")
  },
  {
    name: "enterprise",
    path: "/enterprise",
    component: () => import("/vercel/path0/app/pages/enterprise.vue"),
    children: [
  {
    name: "enterprise-jobs",
    path: "jobs",
    meta: jobsui3znLVjPPi1uvIO7NuS_45QJIZwM8xy_LgNPI4ttmQTUMeta || {},
    component: () => import("/vercel/path0/app/pages/enterprise/jobs.vue")
  },
  {
    name: "enterprise-support",
    path: "support",
    meta: support7YNSDjkZ1vNxFq7kPcTjA0Ia5kB_rl9F5fxFoZzHiPQMeta || {},
    component: () => import("/vercel/path0/app/pages/enterprise/support.vue")
  },
  {
    name: "enterprise-sponsors",
    path: "sponsors",
    meta: sponsorsqSnf0SJ24yxiQ_45ITbF0iFg2TQ4pmCaAwaGHmnSOJVgMMeta || {},
    component: () => import("/vercel/path0/app/pages/enterprise/sponsors.vue")
  },
  {
    name: "enterprise-agencies",
    path: "agencies",
    meta: indexdh5KEN3wnXEhpLEGUlAG2S9f0rx3sSUyx4CAF6Uvbw8Meta || {},
    component: () => import("/vercel/path0/app/pages/enterprise/agencies/index.vue")
  },
  {
    name: "enterprise-agencies-slug",
    path: "agencies/:slug()",
    meta: _91slug_93JKyIiTBK8ePEQRrGalD6GzjrE_45k30_45eVSubgbkdVX6QMeta || {},
    component: () => import("/vercel/path0/app/pages/enterprise/agencies/[slug].vue")
  }
]
  },
  {
    name: "newsletter",
    path: "/newsletter",
    meta: newslettern4GOb5QWXQJ5kM06NFdIlERlYnW_459hqvAMGSs5DZn3kMeta || {},
    component: () => import("/vercel/path0/app/pages/newsletter.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    meta: _91slug_93V5fV_c16JVJ6sOuGL8Wo8dfppaMqN_45wRcqM9kt2Zm5YMeta || {},
    component: () => import("/vercel/path0/app/pages/blog/[slug].vue")
  },
  {
    name: "deploy",
    path: "/deploy",
    meta: indexicxDjlXg087w7w6CUqyqwMldMLtROSaz6jMBwBw1JcUMeta || {},
    component: () => import("/vercel/path0/app/pages/deploy/index.vue")
  },
  {
    name: "deploy-slug",
    path: "/deploy/:slug()",
    meta: _91slug_93_ksw8fq6FRuQ4uaNnbYgAzfG0fklryQ204pz9_RDvaUMeta || {},
    component: () => import("/vercel/path0/app/pages/deploy/[slug].vue")
  },
  {
    name: "modules",
    path: "/modules",
    meta: indexujR_45H8Cu1L2s4oCJBKSzWX3Bn1mbWcGA_oIqsbBAGR8Meta || {},
    component: () => import("/vercel/path0/app/pages/modules/index.vue")
  },
  {
    name: "video-courses",
    path: "/video-courses",
    meta: video_45coursesNEh0ujp9_45IaJpKCGLKWycaqjaVK9Cj04AvwlHbaheL8Meta || {},
    component: () => import("/vercel/path0/app/pages/video-courses.vue")
  },
  {
    name: "docs-slug",
    path: "/docs/:slug(.*)*",
    meta: _91_46_46_46slug_93OUNKk7AMQ1VVXePpxx0zUP0UVhd9HLJ7HMG1pdCiK_45IMeta || {},
    component: () => import("/vercel/path0/app/pages/docs/[...slug].vue")
  },
  {
    name: "modules-slug",
    path: "/modules/:slug()",
    meta: _91slug_93br5bsBMaFUldu9ZW3X_45bIirDQhXcQ74oasqLdJl3UNUMeta || {},
    component: () => import("/vercel/path0/app/pages/modules/[slug].vue")
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/getting-started",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/guide/concepts",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/guide/directory-structure",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/guide/going-further",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/guide/going-further/edge-release-channel",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/bridge",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/migration",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/api/components",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/api/composables",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/api/utils",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/api/kit",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/api/commands",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/api/advanced",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/api/configuration/nuxt-config",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/examples",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/examples/features",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/examples/routing",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/examples/advanced",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/examples/experimental",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/community",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/community/nuxt-community",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/guide/recipes",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/guide/best-practices",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/docs/guide/going-further/custom-routing",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  },
  {
    name: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0Meta?.name,
    path: "/support/us",
    component: component_45stubAqwlhWnB6E9nPYpltJOT3WgWfwEheDKhofVlKMv6WK0
  }
]